import { z } from 'zod/v4';

export const BulkUpdateCollaboratorRequestSchema = z
  .object({
    actionIds: z.array(z.string().min(1)).min(1),
    add: z.array(z.string().min(1)).default([]),
    remove: z.array(z.string().min(1)).default([]),
  })
  .refine(body => body.add.length + body.remove.length > 0, {
    message: 'Must provide at least one collaborator to add or remove',
  });

export type BulkUpdateCollaboratorRequest = z.infer<
  typeof BulkUpdateCollaboratorRequestSchema
>;

export const BulkUpdateCollaboratorResponseSchema = z.object({
  updatedCount: z.number(),
  message: z.string(),
});

export type BulkUpdateCollaboratorResponse = z.infer<
  typeof BulkUpdateCollaboratorResponseSchema
>;
